import { call, put, select } from "redux-saga/effects";
import { notify } from "../../../services/notification";
import api, { makeOptions, queryBuilder } from "../../../services/api";
import ActionsBranchInvoicesList from "../../ducks/branch-invoices/list";

const getAuthData = (state) => state.auth.data;

export function* fetch(action) {
  try {
    const { params } = action;
    const query = params ? queryBuilder(params) : "";
    const url = `branch-invoice?${query}`;
    const authData = yield select(getAuthData);
    const { data } = yield call(api.get, url, makeOptions(authData));

    yield put(
      ActionsBranchInvoicesList.success(data.branch_invoices, data.pagination)
    );
  } catch (err) {
    notify("error", err.response.data.error.message);
    yield put(
      ActionsBranchInvoicesList.failure(err.response.data.error.message)
    );
  }
}
